import { useCallback, useState } from "react";
export const useAuditLogsPagination = ({ initialPageSize = 50 } = {})=>{
    const [pageSize, setPageSizeState] = useState(initialPageSize);
    const [currentToken, setCurrentToken] = useState(undefined);
    const [tokenHistory, setTokenHistory] = useState([
        undefined
    ]);
    const resetPagination = useCallback(()=>{
        setCurrentToken(undefined);
        setTokenHistory([
            undefined
        ]);
    }, []);
    const goToNextPage = useCallback((nextToken)=>{
        if (!nextToken) {
            return;
        }
        setTokenHistory((previous)=>[
                ...previous,
                currentToken
            ]);
        setCurrentToken(nextToken);
    }, [
        currentToken
    ]);
    const goToPreviousPage = useCallback(()=>{
        if (tokenHistory.length <= 1) {
            return;
        }
        const newHistory = [
            ...tokenHistory
        ];
        newHistory.pop();
        setTokenHistory(newHistory);
        setCurrentToken(newHistory[newHistory.length - 1]);
    }, [
        tokenHistory
    ]);
    const setPageSize = useCallback((size)=>{
        setPageSizeState(size);
        setCurrentToken(undefined);
        setTokenHistory([
            undefined
        ]);
    }, []);
    return {
        pageSize,
        currentToken,
        currentPage: tokenHistory.length,
        hasPreviousPage: tokenHistory.length > 1,
        resetPagination,
        goToNextPage,
        goToPreviousPage,
        setPageSize
    };
};
export default useAuditLogsPagination;
